import { Box, IconButton } from '@mui/material';
import { ArrowLeftIcon } from '../../components/shared/CustomIcons';

import { EYE_OPS_IMAGE_PATH } from '../../constants';
const LoginRegistrationHeader = ({
  showBackArrow = true,
}: {
  showBackArrow?: boolean;
}) => {
  return (
    <>
      <Box gap={4} pt={8} className="d-flex flex-column align-items-start">
        {showBackArrow && (
          <IconButton
            aria-label="back"
            sx={{ color: 'primary', p: 0, m: 0 }}
            onClick={() => history.back()}
          >
            <ArrowLeftIcon sx={{ fontSize: 40 }} />
          </IconButton>
        )}
        <img
          src={EYE_OPS_IMAGE_PATH}
          style={{ alignSelf: 'start' }}
          alt="Profile"
          loading="lazy"
        />
      </Box>
    </>
  );
};

export default LoginRegistrationHeader;
